import Vue from 'vue';
// import App from './App.vue';
import Placeholder from './components/Placeholder.vue';
// import router from './router';
import './registerServiceWorker';
import WebFont from 'webfontloader';
import VueMeta from 'vue-meta';
import VueAnalytics from 'vue-analytics';

Vue.config.productionTip = false;

WebFont.load({
  google: { families: ['Crimson Pro:300,500,500i', 'Source Sans Pro:600,700'] }
});

Vue.use(VueMeta);

Vue.use(VueAnalytics, {
  id: 'UA-39766439-3',
  debug: {
    sendHitTask: false
  }
});

new Vue({
  render: h => h(Placeholder)
}).$mount('#app');
